const doc = [({"en":({"adminConstantHotelOptionApplicableConditionType":({"all":"All", "specifiedPlans":"Specified Plans"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;